/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

function isDev () {    
  return `${process.env.VUE_APP_TYPE}` == 'DEV';
}

function isOverlap(row, top, bottom) {
  let over_top = Math.max(top, row.top)
  let over_bottom = Math.min(bottom, row.bottom)
  let over_height = over_bottom - over_top
  if ( (over_height / (bottom - top)) < 0.5) {
    return false
  }
  return true
}

function sorted (pred) {
  let rows = []
  for (let n in pred) {
    let word = pred[n]
    let left = Math.min(word.points[0].x, word.points[3].x)
    // let right = Math.max(word.points[1].x, word.points[2].x)
    let top = Math.max(word.points[0].y, word.points[1].y)
    let bottom = Math.min(word.points[2].y, word.points[3].y)
    pred[n].left = left
    let flag = false
    for (let row of rows) {
      if (isOverlap(row, top, bottom)) {
        row.top = Math.min(row.top, top)
        row.bottom = Math.max(row.bottom, bottom)
        row.indices.push(n)
        flag = true
        break
      }
    }
    if (!flag) {
      rows.push({top: top, bottom: bottom, indices: [n]})
    }
  }
  rows.sort(function(a, b) {
    return a.top - b.top
  })
  for (let n in rows) {
    let row = rows[n]
    for (let np of row.indices) {
      pred[np].row = n
    }
  }
  pred.sort(function(a, b) {
    if (a.row == b.row) {
      return a.left - b.left
    }
    return a.row - b.row
  })
  return pred
}

export default {
  isDev,
  sorted
}
